
const ShareData = {
    namespaced: true,
    getters: {},
    state: {
        shareConfig: {
            title: '',
            desc: '',
            imgUrl: ''
        },
        iswx: false,
    },
    mutations: {
        SETSHARE(state, data) {
            state.shareConfig = { ...state.shareConfig, ...data }
        },
        SETISWX(state, data) {
            state.iswx = data
        },
    },
    actions: {},
}
export default ShareData